import {
  MEDIA_ADDITIONAL_DOCUMENT_TYPE,
  MEDIA_IDENTITY_DOCUMENT_TYPE
} from "../constants";

function toggleElementSound(elem, shouldMute) {
  elem.muted = shouldMute;
}

export function toggleAllElementsSound(isSoundOn) {
  document
    .querySelectorAll("audio")
    .forEach(elem => toggleElementSound(elem, isSoundOn));
}

export function isAdditionalDocument(mediaItem) {
  return [
    MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_ADDRESS,
    MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_TIN,
    MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_VAT,
    MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_CRN,
    MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_POB
  ].includes(mediaItem.givenDocumentType);
}

export function hasIdentityDocument(media) {
  if (!media?.length) {
    return false;
  }

  return media?.some(item =>
    Object.values(MEDIA_IDENTITY_DOCUMENT_TYPE).includes(item.givenDocumentType)
  );
}

export function hasAdditionalDocuments(media) {
  if (!media?.length) {
    return false;
  }

  return media?.some(item =>
    Object.values(MEDIA_ADDITIONAL_DOCUMENT_TYPE).includes(
      item.givenDocumentType
    )
  );
}
